import {registerTestEchoExecutors} from 'src/offline/testEchoExecutors';

// Composition root for the offline test page's echo executors.
registerTestEchoExecutors();
